// https://vuex.vuejs.org/en/getters.html

export default {
  orders(state) {
    return state.orders;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
